import { Clock, Lightbulb, Percent, TrendingUp } from "lucide-react";

import {
  BidTypeEnum,
  OfferAttractivenessRecommendationStatusEnum,
} from "@/features/common/enums";

export function getQualityTitle(score: number): string {
  if (score < 2) return "Low likelihood to convert";
  if (score < 5) return "Medium likelihood to convert";
  if (score < 9) return "High likelihood to convert";

  return "Very high likelihood to convert";
}

export function getRecommendationIcon(
  status: OfferAttractivenessRecommendationStatusEnum,
) {
  const iconClass = "size-3 text-primary";

  switch (status) {
    case OfferAttractivenessRecommendationStatusEnum.INCREASE_AMOUNT:
      return <TrendingUp className={iconClass} />;
    case OfferAttractivenessRecommendationStatusEnum.LOWER_COMPARABLE_INTEREST_RATE:
      return <Percent className={iconClass} />;
    case OfferAttractivenessRecommendationStatusEnum.INCREASE_REPAYMENT_TIME:
      return <Clock className={iconClass} />;
    default:
      return <Lightbulb className={iconClass} />;
  }
}

export function getAttractivenessColor(
  score: number,
  style: "number" | "gauge",
) {
  if (style === "number") {
    if (score <= 1) return "bg-red-500";
    if (score <= 4) return "bg-orange-500";
    if (score <= 8) return "bg-green-400";
  }
  if (score < 1) return "bg-red-500";
  if (score < 4) return "bg-orange-500";
  if (score < 8) return "bg-green-400";

  return "bg-green-500";
}

export function getAlertVariant(score: number | null | undefined) {
  if (score === null || score === undefined) return "info";
  if (score <= 1) return "critical";
  if (score <= 4) return "warning";

  return "success";
}

export function getRecommendationDisplayText(
  status: OfferAttractivenessRecommendationStatusEnum,
  bidType: BidTypeEnum | undefined,
  apiStatusText: string,
): string {
  switch (status) {
    case OfferAttractivenessRecommendationStatusEnum.INCREASE_AMOUNT:
      return bidType === BidTypeEnum.FACTORING
        ? "Increase the purchase limit"
        : apiStatusText;
    case OfferAttractivenessRecommendationStatusEnum.INCREASE_REPAYMENT_TIME:
      if (bidType === BidTypeEnum.REAL_ESTATE) return "Increase the loan term";

      if (bidType === BidTypeEnum.REVOLVING_CREDIT) {
        return "Lower the amortisation per month";
      }

      return apiStatusText;
    default:
      return apiStatusText;
  }
}
